import { Controller } from "stimulus";

export default class extends Controller {
  destroy() {
    this.element.remove();
  }
}
